import React, { useCallback } from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Model from '../../../../model';
import './index.sass';

const { block, el } = bem('cancel-button');
const CancelButton = ({order}) => {
    const { openCancelForm } = Model.modal;

    const ticketId = order.isTicket ? order.id : null;
    const orderId = order.isTicket ? null : order.id;
    const meetingType = order.data.service.meetingType;

    const clickHandler = useCallback(() => {
        openCancelForm({ ticketId, orderId, meetingType, refundSum: null })
    }, [order]);

    return (
        <div className={block()} onClick={clickHandler}>
            <div className={el('text')}>
                <Text>Отменить запись</Text>
            </div>
        </div>
    )
}

export default CancelButton;
